import React from 'react';
import styled from 'styled-components';

import TaglineHero from '../elements/TaglineHero';

import { vw, vwMobile, vwTablet } from 'src/styles/utils';
import media from 'src/styles/media';

const videos = [
  'https://media.bamdigital.com/gryphon/gryphon-royalcurator/rc-hero-1-1080p.mp4',
  'https://media.bamdigital.com/gryphon/gryphon-royalcurator/rc-hero-2-1080p.mp4',
  'https://media.bamdigital.com/gryphon/gryphon-royalcurator/rc-hero-3-1080p.mp4',
];

const Hero = () => {
  const handleSrc = () => {
    const random = Math.floor(Math.random() * Math.floor(3));
    return videos[random];
  };

  return (
    <Root>
      <Video src={handleSrc()} autoPlay muted playsInline />
      <Wrapper>
        <TaglineHero />
      </Wrapper>
    </Root>
  );
};

const Root = styled.div`
  height: 100vh;
  position: relative;
  padding: 0 ${vwMobile(60)};
  background-color: #1e1e1e;
  h1,
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  img {
    max-width: 100%;
  }
  @media (min-width: ${media.xsup}) {
    padding: 0 ${vwTablet(40)};
  }
  @media (min-width: ${media.mdup}) {
    padding: 0 ${vw(60)};
    min-height: ${vw(700)};
  }
`;

const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 ${vwMobile(12)};
  @media (min-width: ${media.xsup}) {
    padding: 0 ${vwTablet(32)};
  }
  @media (min-width: ${media.mdup}) {
    padding: 0;
  }
`;

export default Hero;
